const CurrentBalance = ({ balance }: CurrentBalanceProps) => (
    <>
    <h2 style={{color: "cyan"}}className="mt-2 p-2 text-l font-semibold text-700">
        {/* <h6 style={{color: "lightblue"}}>Welcome!</h6> */}
        {balance && `Your Current Balance: ${balance} ETH`}
    </h2>
    </>
)

type CurrentBalanceProps = {
    balance: string
}

export default CurrentBalance;